import { useApiClient } from "@/api/client";
import DashboardDO = App.Data.DashboardDO;
import useToast from "@/ui/composables/useToast";

export async function downloadDashboardAsPdf(dashboard: DashboardDO) {
	const toast = useToast();
	const id = toast.loading("Preparing export...", {
		dismissible: true,
	});

	const response = await useApiClient("dashboard").downloadDashboard(dashboard);

	toast.dismiss(id);

	if (response.isErr()) {
		toast.error("Sorry something went wrong...", { timeout: 5000 });
		return;
	}
}
